import React, { useEffect } from "react";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import HeroInteractive from "./components/HeroInteractive";
import ScrollytellingMetrics from "./components/ScrollytellingMetrics";
import InteractiveUseCases from "./components/InteractiveUseCases";

export default function TapnPage() {
  // Ensure scroll is at top on load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white text-[#0A0A0A] min-h-screen selection:bg-indigo-500/30">
      <Navbar />
      
      <main className="overflow-x-hidden pt-20">
        <HeroInteractive />
        <ScrollytellingMetrics />
        <InteractiveUseCases />
      </main>

      <Footer />
    </div>
  );
}
